<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      short-title="ZS"
      :title="storeName"
      :url="url"
      :logo="logo"
      >
      <template slot-scope="props" slot="links">
        <div v-if="myGroup == 'Administrator'">
          <sidebar-item :link="{name: $t('dashboard'), icon: 'tim-icons icon-chart-bar-32', path: '/dashboard'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Search'), icon: 'tim-icons icon-zoom-split', path: '/system/search'}"></sidebar-item>
          <sidebar-item :link="{name: $t('STORE'), icon: 'tim-icons icon-bag-16', path: '/products'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Clients'), icon: 'tim-icons icon-single-02', path: '/clients'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Orders'), icon: 'tim-icons icon-cart', path: '/orders'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Payments'), icon: 'tim-icons icon-coins', path: '/payments'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Reviews'), icon: 'tim-icons icon-satisfied', path: '/reviews'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Requests'), icon: 'tim-icons icon-send', path: '/requests'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Accounting'), icon: 'tim-icons icon-money-coins', path: '/accounting'}"></sidebar-item>
          <sidebar-item :link="{name: $t('MARKETING'), icon: 'tim-icons icon-email-85', path: '/marketing'}"></sidebar-item>
          <sidebar-item :link="{name: $t('System'), icon: 'tim-icons icon-settings', path: '/system'}"></sidebar-item>
          <sidebar-item :link="{name: $t('AI ASSISTANT'), icon: 'tim-icons icon-spaceship', path: '/ai'}"></sidebar-item>
        </div>
        <div v-if="myGroup == 'Staff'">
          <sidebar-item :link="{name: $t('dashboard'), icon: 'tim-icons icon-chart-bar-32', path: '/dashboard'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Search'), icon: 'tim-icons icon-zoom-split', path: '/system/search'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Clients'), icon: 'tim-icons icon-single-02', path: '/clients'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Orders'), icon: 'tim-icons icon-cart', path: '/orders'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Payments'), icon: 'tim-icons icon-coins', path: '/payments'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Reviews'), icon: 'tim-icons icon-satisfied', path: '/reviews'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Requests'), icon: 'tim-icons icon-send', path: '/requests'}"></sidebar-item>
          <sidebar-item :link="{name: $t('MARKETING'), icon: 'tim-icons icon-email-85', path: '/marketing'}"></sidebar-item>
        </div>
        <div v-if="myGroup == 'Client' || myGroup == 'Reseller'">
          <sidebar-item :link="{name: $t('dashboard'), icon: 'tim-icons icon-chart-bar-32', path: '/dashboard'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Products'), icon: 'tim-icons icon-bag-16', path: '/my/products'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Orders'), icon: 'tim-icons icon-cart', path: '/my/orders'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Payments'), icon: 'tim-icons icon-coins', path: '/my/payments'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Reviews'), icon: 'tim-icons icon-satisfied', path: '/my/reviews'}"></sidebar-item>
          <sidebar-item :link="{name: $t('Requests'), icon: 'tim-icons icon-send', path: '/my/requests'}"></sidebar-item>
        </div>
      </template>
    </side-bar>
    <!-- Floating settings gear removed - settings now in user menu -->
    <!-- <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share> -->
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <!-- Horizontal Tabs Navigation -->
        <tabs-nav v-if="currentSection" :section="currentSection"></tabs-nav>
        
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';
import TabsNav from '../../components/TabsNav.vue';
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
    TabsNav
  },
  data() {
    return {
      myGroup: '',
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
  computed:{
    ...mapGetters([
      'getResources'
    ]),
    storeName() {
      return (this.getResources && this.getResources.store) ? this.getResources.store : 'Z-Store';
    },
    url() {
      return (this.getResources && this.getResources.url) ? this.getResources.url : '/';
    },
    logo() {
      const logo = (this.getResources && this.getResources.logo) ? this.getResources.logo : null;
      if (!logo) return 'img/icon-vue.png';
      if (logo.startsWith('http') || logo.startsWith('data:')) return logo;
      return 'img/' + logo;
    },
    currentSection() {
      const path = this.$route.path;
      if (path.startsWith('/products')) return 'products';
      if (path.startsWith('/orders')) return 'orders';
      if (path.startsWith('/payments') && !path.startsWith('/payments/details')) return 'payments';
      if (path.startsWith('/accounting')) return 'accounting';
      if (path.startsWith('/marketing')) return 'marketing';
      if (path.startsWith('/system') && !path.startsWith('/system/search')) return 'system';
      return null;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  mounted() {
    this.initScrollbar();
    this.$http.get('profile')
    .then(response => response.json())
    .then(response => {
        this.myGroup = response.type;
    });
    // Listen for sidebar color changes from navbar
    this.$root.$on('change-sidebar-color', (color) => {
      this.sidebarBackground = color;
    });
  },
  beforeDestroy() {
    this.$root.$off('change-sidebar-color');
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
